
let setting =  JSON.parse(localStorage.getItem('setting') || '{}') ;

let VUE_APP_ENV_NAME = setting.envName; //环境名称
let VUE_APP_PROJECT_NAME = setting.projectName;//项目名称
let VUE_APP_PLATFORM = setting.platform; //平台

setting = setting.envInfo || {};
let BASE_REPORT_URL = setting.BASE_REPORT_URL;//报表地址
let VUE_APP_BASE_REPORT_URL = setting.BASE_REPORT_URL;//报表地址
let VUE_APP_REPORT_HTML = setting.VUE_APP_REPORT_HTML;//报表脚本存放位置
let VUE_APP_ENVIRONMENT = setting.VUE_APP_ENVIRONMENT;//报表存放文件夹
let VUE_APP_REPORT_ENVIRONMENT = setting.VUE_APP_ENVIRONMENT;//报表存放文件夹
let VUE_APP_TITLE_NAME = setting.VUE_APP_TITLE_NAME;//系统名字
let VUE_APP_TOP_NAV_NAME = setting.VUE_APP_TOP_NAV_NAME;//顶部导航栏名字
let FILE_VIEW_URL = setting.VUE_APP_FILE_VIEW_URL;//文件预览地址
let VUE_APP_HOME_NAME = setting.VUE_APP_HOME_NAME;//主页左侧系统名字

// let url = window.location.href;
let TENANTID = "";
// if(url.indexOf("localhost")>-1){
//     TENANTID = process.env.VUE_APP_TENANTID; //租户id
// }else{
    TENANTID = JSON.parse(localStorage.getItem('saber-tenantId') || '{}').content || "" ; //租户id
// }
// let TENANTID = JSON.parse(localStorage.getItem('saber-tenantId') || '{}').content || "" ; //租户id
let BACKGROUND = JSON.parse(localStorage.getItem('saber-background') || '{}').content || "" ; //登录页背景图

let LOGIN_CAPTCHA_MODE = setting.LOGIN_CAPTCHA_MODE == 'true' ? true : false;//平台登陆 验证码 开关 true打开 false 关闭



export default{
    BACKGROUND,
    TENANTID,
    LOGIN_CAPTCHA_MODE,
    VUE_APP_PLATFORM,
    VUE_APP_ENV_NAME,
    VUE_APP_PROJECT_NAME,
    BASE_REPORT_URL,
    VUE_APP_BASE_REPORT_URL,
    FILE_VIEW_URL,
    VUE_APP_ENVIRONMENT,
    VUE_APP_REPORT_ENVIRONMENT,
    VUE_APP_TITLE_NAME,
    VUE_APP_TOP_NAV_NAME,
    VUE_APP_REPORT_HTML,
    VUE_APP_HOME_NAME
}
